import { getToken, onMessage } from "firebase/messaging";
import { messaging } from "./firebase";

const VAPID_KEY = "BKQQV0CrP1ygWoAguz9JnvB1L-FOd2zEY5MkXtJnlJmD1yaufBfNFtUDtSqO8qn57WE0CdHVwO83MblkhONLstI";


//طلب إذن الإشعارات والحصول على التوكن
export const requestNotificationPermission = async () => {
  try {
    //يطلب من المستخدم السماح بالإشعارات.
    const permission = await Notification.requestPermission();
    if (permission === "granted") {
        //يتأكد من أن الـ 
        // Service Worker
        // مسجل وجاهز
        const registration = await navigator.serviceWorker.ready;
        //يحصل على
        // FCM Token
        // الخاص بالمتصفح.
        const token = await getToken(messaging, { vapidKey: VAPID_KEY, serviceWorkerRegistration: registration});
        localStorage.setItem("fcm_token", token);
        return token;
    } else {
      console.log("Notification permission denied");
    }
  } catch (error) {
    console.error("Error getting token", error);
  }
};

//الاستماع للإشعارات أثناء فتح الموقع
export const listenForMessages = () => {
  onMessage(messaging, (payload) => {
    console.log("Foreground message:", payload);
    // alert(`${payload.notification.title}\n${payload.notification.body}`);
    if (Notification.permission === "granted") {
      new Notification(payload.notification?.title || "إشعار جديد", {
        body: payload.notification?.body || "",
        icon: "logo.png", // تأكد أن الأيقونة داخل public
      });
    }
  });
};